
import Close from "vue-material-design-icons/Close";
import Fullscreen from "vue-material-design-icons/Fullscreen.vue";

export default {
  name: "CardBuscaTerminal",
  components: {
    Close,
    Fullscreen,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      isFullScreen: false,
    };
  },
  methods: {
    requestFullScreen() {
      this.isFullScreen = true;
      const elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      }
    },
    closeFullscreen() {
      this.isFullScreen = false;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
  },
  computed: {
    isMobile() {
      return this.windowWidth < 992;
    },
  },
};
